<mat-sidenav-container [ngClass]="isOpened ? 'side-nav-opened' : 'side-nav-closed'">
  <mat-sidenav #sidenav mode="side" [(opened)]="opened"></mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
      <ul class="nav-links">
        <li class="accordion__list-item" *ngFor="let link of navigationLinks">
          <app-navigation-desktop-link
          *ngIf="isAuthorizedToView(link)"
          [navigationLink]="link"
          [unlockCase]="unlockCase(link)"
          [externalLink]="isExternalLink(link)"
          [forceReload]="shouldForceReload(link)"
          [opened]="isOpened"
          ></app-navigation-desktop-link>
        </li>
      </ul>
      <div class="nav-image" *ngIf="opened">
        <img src="../../../../assets/img/USAN-logo_large.png" />
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>